import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { useEffect } from "react";
import { AnalyticsKPIBar, Skeleton } from "@flat-ui";
import { buildKpiBarItems } from "@components/analytics/in-house/utils/analytics-utils";
import { useCompanyId } from "@context-providers/company-id-provider";
import { inHouseAnalyticsDashboardFetchingStatusSelector, inHouseAnalyticsDashboardSummarySelector } from "@store/analytics/analytics-selector";
import { fetchInHouseAnalyticsDashboard } from "@store/analytics/analytics-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { InHouseAnalyticsEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * Renders the KPI bar from the analytics dashboard summary and lets the user pick
 * the metric that drives the chart below. Selecting a metric is tracked in Amplitude.
 */
export function AnalyticsCategoryNavigation(t0) {
  const $ = _c(15);
  const {
    selectedRange,
    selectedMetricKey,
    onSelectMetric
  } = t0;
  const companyId = useCompanyId();
  const dispatch = useAppDispatch();
  const {
    trackEvent
  } = useTrackEvent();
  const summary = useAppSelector(inHouseAnalyticsDashboardSummarySelector);
  const fetchingStatus = useAppSelector(inHouseAnalyticsDashboardFetchingStatusSelector);
  let t1;
  let t2;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== selectedRange) {
    t1 = () => {
      dispatch(fetchInHouseAnalyticsDashboard({
        companyId,
        selectedRange
      }));
    };
    t2 = [companyId, selectedRange, dispatch];
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = selectedRange;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== onSelectMetric || $[6] !== trackEvent) {
    t3 = function handleSelect(metricKey) {
      trackEvent({
        name: InHouseAnalyticsEvents.selectMetric,
        props: {
          metric: metricKey
        }
      });
      onSelectMetric(metricKey);
    };
    $[5] = onSelectMetric;
    $[6] = trackEvent;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSelect = t3;
  if (fetchingStatus === "pending") {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Skeleton variant="rectangular" sx={{
        height: "135px"
      }} />;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t4;
  if ($[9] !== summary) {
    t4 = buildKpiBarItems(summary);
    $[9] = summary;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== handleSelect || $[12] !== selectedMetricKey || $[13] !== t4) {
    t5 = <Box data-testid="analytics-category-navigation"><AnalyticsKPIBar items={t4} selectedValue={selectedMetricKey} onSelect={handleSelect} /></Box>;
    $[11] = handleSelect;
    $[12] = selectedMetricKey;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}